import { connect } from "react-redux"
import { compose } from "redux"
import ProgressReports from '../components/progress-reports'
import { getVariables } from "../utilities/route"
import { withData } from "../decorators/with-data"
import gql from "graphql-tag"
import { withTranslations } from "../decorators/with-translations"
import { setPrFilters, setSubmitError } from '../actions/survey'
import {
  QUESTIONNAIRE_FRAGMENT,
  SURVEY_LIST_PARAMETER_FRAGMENT,
  SURVEY_TREE_PARAMETER_FRAGMENT
} from '../graphql/fragments'

const paramsQuery = gql`
  query FinishPageParams(
    $surveyId: UUID!
    $languageCode: String
  ) {
    questionnaire(languageCode: $languageCode) {
      ...QuestionnaireFragment
    }
    respondentParameters(
      surveyId: $surveyId
      languageCode: $languageCode
    ) {
      ...SurveyListParameter
      ...SurveyTreeParameter
    }
  }
  ${QUESTIONNAIRE_FRAGMENT}
  ${SURVEY_LIST_PARAMETER_FRAGMENT}
  ${SURVEY_TREE_PARAMETER_FRAGMENT}
`;

const mapStateToProps = ({ survey: { prFilters, prSortingType, sortAscending, submitError } }) => {
  return {
    prFilters,
    prSortingType,
    sortAscending,
    submitError
  };
};

const mapDispatchToProps = (dispatch, props) => {
  return {
    onSetPrFilters: prFilters => {
      dispatch(setPrFilters(prFilters))
    },
    onSubmitError: (error) => {
      dispatch(setSubmitError(error));
    }
  };
};

export default compose(
  withTranslations,
  connect(mapStateToProps, mapDispatchToProps),
  withData(paramsQuery, {
    options: (props) => {
      const variables = { ...getVariables(props) }

      return {
        ...variables,
        fetchPolicy: "network-only",
      };
    },
  }),
)(ProgressReports)



// WEBPACK FOOTER //
// ./src/containers/progress-reports.js